import { Component, OnInit } from "@angular/core";
import { AngularFireAuth } from '@angular/fire/auth';
import { User } from 'firebase';
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})

export class AppComponent implements OnInit {
  title = "app";
  public _opened = false;
  public _toggleSidebar(): void {
    this._opened = !this._opened;
  }

  user: User;

  constructor(
    private readonly angularFireAuth: AngularFireAuth
  ) { }

  async login(email: string, password: string) {
    return await this.angularFireAuth.auth.signInWithEmailAndPassword(email, password);
  }

  async ngOnInit(): Promise<void> {
    await this.login("surasak@builk.com", "2037Ngip")
      .then(value => {
        console.log('Nice, it worked!', value);
      })
      .catch(err => {
        console.log('Something went wrong:', err.message);
      });

  }
}
